export default __webpack_public_path__ + "static/media/reveal.ae2de8e7.wav";